/**
 * @generated SignedSource<<a6c06084abfed867f8e09b4fd667e89e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteApplianceModelInput = {
  applianceModelId: string;
};
export type ApplianceModel_deleteApplianceModel_Mutation$variables = {
  input: DeleteApplianceModelInput;
};
export type ApplianceModel_deleteApplianceModel_Mutation$data = {
  readonly deleteApplianceModel: {
    readonly applianceModel: {
      readonly id: string;
    };
  } | null;
};
export type ApplianceModel_deleteApplianceModel_Mutation = {
  response: ApplianceModel_deleteApplianceModel_Mutation$data;
  variables: ApplianceModel_deleteApplianceModel_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteApplianceModelPayload",
    "kind": "LinkedField",
    "name": "deleteApplianceModel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplianceModel",
        "kind": "LinkedField",
        "name": "applianceModel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ApplianceModel_deleteApplianceModel_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApplianceModel_deleteApplianceModel_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cac008b35f4435245740e36e87713206",
    "id": null,
    "metadata": {},
    "name": "ApplianceModel_deleteApplianceModel_Mutation",
    "operationKind": "mutation",
    "text": "mutation ApplianceModel_deleteApplianceModel_Mutation(\n  $input: DeleteApplianceModelInput!\n) {\n  deleteApplianceModel(input: $input) {\n    applianceModel {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "70e861d19d2c7b76152ac4f3dfc21890";

export default node;
